<div
  class="grid-body p-4 border-b"
  [ngClass]="{
    'bg-blue-bright/10': isOpen || activeSearchOptions?.length > 0,
    'bg-grey-light-concrete': !isOpen && activeSearchOptions?.length == 0,
  }"
>
  <div class="flex items-center">
    <ion-icon
      class="text-2xl p-2"
      name="filter-outline"
      [ngClass]="{ 'text-blue-bright': isOpen || activeSearchOptions?.length > 0 }"
    ></ion-icon>
    <div class="w-full overflow-visible">
      <div
        id="mainSearchbox"
        class="flex w-full items-center justify-between border shadow border-solid rounded-t-2xl py-1.5 px-2 cursor-text bg-white"
        [ngClass]="{
          'border-blue-bright ring-2 ring-blue-bright transition': isOpen || activeSearchOptions?.length > 0,
          'border-grey-concrete': !isOpen && !activeSearchOptions?.length,
          'rounded-b-2xl ring-transparent': !isOpen,
          'border-b-0': isOpen,
        }"
        (click)="openAdvancedSearch($event)"
      >
        <div class="flex items-center gap-1.5 flex-wrap">
          @for (activeOption of activeSearchOptions; track activeOption.key) {
            <div class="flex items-center">
              <div
                class="bg-blue-bright text-white rounded-l-full py-1 px-2"
                [style.opacity]="toDeleteFilter && activeOption.key === filterToDelete.key ? '0.4' : '1'"
              >
                {{ activeOption.title }}
              </div>
              @if (activeOption.editMode) {
                <div>
                  @if (['string', 'number'].includes(activeOption.type) && !activeOption.suggestedValues?.length) {
                    <input
                      class="h-min border-none hover:border-none bg-transparent text-xs py-0 px-2 shadow-none ring-0"
                      [style.width.px]="!!activeOption.fieldWidth ? activeOption.fieldWidth : 100"
                      id="search-{{ activeOption.key }}"
                      [value]="activeOption.value"
                      [placeholder]="!!activeOption.placeholder ? activeOption.placeholder : ''"
                      [type]="activeOption.type == 'number' ? 'number' : 'text'"
                      (keydown)="removeFilterOnBackspace($event, activeOption)"
                      (keyup.enter)="editSearchOption(activeOption, false, $event.target.value)"
                      (blur)="editSearchOption(activeOption, false, $event.target.value)"
                    />
                  }
                  @if (['dateRange', 'fromDate', 'toDate'].includes(activeOption.type)) {
                    <app-date-picker
                      [datePickerType]="activeOption.type"
                      [fromDate]="activeOption.value?.min"
                      [toDate]="activeOption.value?.max"
                      [maxDate]="maxDate"
                      [removableDate]="true"
                      (selectedDates)="
                        editSearchOption(activeOption, false, { min: $event.fromDate, max: $event.toDate })
                      "
                    >
                    </app-date-picker>
                  }
                  @if (activeOption.type == 'currencyRange' || activeOption.type == 'numberRange') {
                    <app-number-picker
                      [currencyPicker]="activeOption.type == 'currencyRange'"
                      [min]="activeOption.value?.min"
                      [max]="activeOption.value?.max"
                      (selectedValues)="editSearchOption(activeOption, false, { min: $event.min, max: $event.max })"
                    >
                    </app-number-picker>
                  }
                  @if (activeOption.suggestedValues?.length > 0) {
                    <div class="overflow-visible h-[24px]">
                      @for (suggestedValue of activeOption.suggestedValues; track suggestedValue.title) {
                        <div
                          class="bg-grey-concrete text-grey-blue relative z-50 hover:text-grey-concrete hover:bg-grey-blue py-1 px-2 cursor-pointer first:rounded-tr-lg last:rounded-br-lg shadow-lg"
                          (click)="editSearchOption(activeOption, false, suggestedValue.title)"
                        >
                          {{ suggestedValue.title }}
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                <div
                  class="flex has-[.remove:hover]:bg-bright-crimson has-[.remove:hover]:text-white items-center bg-grey-concrete text-grey-blue rounded-r-full py-1 px-2 peer"
                  [style.opacity]="toDeleteFilter && activeOption.key === filterToDelete.key ? '0.4' : '1'"
                >
                  <span [tooltip]="'Click to Edit'" (click)="editSearchOption(activeOption, true, activeOption.value)">
                    {{
                      ['currencyRange', 'numberRange'].includes(activeOption.type)
                        ? activeOption.value?.min && activeOption.value?.max
                          ? (activeOption.type == 'currencyRange' ? currencySymbol + ' ' : '') +
                            activeOption.value?.min +
                            ' - ' +
                            (activeOption.type == 'currencyRange' ? currencySymbol + ' ' : '') +
                            activeOption.value?.max
                          : activeOption.value?.min
                            ? (activeOption.type == 'currencyRange' ? currencySymbol + ' ' : '') +
                              activeOption.value?.min +
                              ' or more'
                            : (activeOption.type == 'currencyRange' ? currencySymbol + ' ' : '') +
                              activeOption.value?.max +
                              ' or less'
                        : activeOption.type == 'dateRange'
                          ? activeOption.value?.min && activeOption.value?.max
                            ? (activeOption.value?.min | amDateFormat: 'D MMM YYYY') +
                              ' - ' +
                              (activeOption.value?.max | amDateFormat: 'D MMM YYYY')
                            : activeOption.value?.min
                              ? 'after ' + (activeOption.value?.min | amDateFormat: 'D MMM YYYY')
                              : 'before ' + (activeOption.value?.max | amDateFormat: 'D MMM YYYY')
                          : activeOption.type == 'fromDate'
                            ? (activeOption.value?.min | amDateFormat: 'D MMM YYYY')
                            : activeOption.type == 'toDate'
                              ? (activeOption.value?.max | amDateFormat: 'D MMM YYYY')
                              : activeOption.type == 'multiSelect'
                                ? activeOption.value?.length + ' Selected'
                                : activeOption.type == 'userSelect'
                                  ? activeOption.readableValue
                                  : activeOption.value
                    }}
                  </span>
                  @if (!activeOption.disableRemove) {
                    <ion-icon
                      (click)="removeSearchOption(activeOption)"
                      class="ml-2 size-4 text-grey-blue cursor-pointer -mr-1 remove hover:text-white transition"
                      name="close-circle"
                      tooltip="Remove filter"
                    ></ion-icon>
                  }
                </div>
              }
            </div>
          }
          @if (!isEditMode) {
            <input
              id="filterInput"
              #filterInput
              class="w-56 p-0 pl-2 h-min border-none hover:border-none bg-transparent text-sm shadow-none ring-0 overflow-visible"
              (keyup)="traverseSearchOptions($event)"
              (input)="updateSearchValue($event)"
              (keydown.backspace)="removeFilterOnBackspace($event)"
              (keydown.enter)="selectSearchOption(focusedSearchOption)"
              (blur)="closeAdvancedSearch($event)"
              placeholder="search by keyword or phrase..."
            />
          }
        </div>
        @if (activeSearchOptions?.length == 0) {
          <ion-icon class="text-lg p-1 text-secondary" name="search-outline"> </ion-icon>
        } @else if (activeSearchOptions?.length > 0 && !resetSearch) {
          <button
            class="max-md:btn-danger-secondary max-md:border-0 max-md:shadow-none max-md:p-0 btn-default hover:btn-danger-secondary my-auto mx-0 p-0 flex items-center gap-1 px-0.5 pr-2 self-end transition"
            (click)="removeAllSearchOptions()"
            tooltip="Clear All filters"
            id="clear-all-filters"
          >
            <ion-icon class="size-7 cursor-pointer shrink-0" name="close-circle"></ion-icon>
            <div class="max-md:hidden">Clear</div>
          </button>
        } @else if (activeSearchOptions?.length > 0 && resetSearch) {
          <button
            class="max-md:btn-danger-secondary max-md:border-0 max-md:shadow-none max-md:p-0 btn-default hover:btn-warning-secondary m-0 p-0 flex items-center gap-1 px-0.5 pr-2 self-end transition"
            (click)="resetSearchOptions()"
            id="reset-filters"
          >
            <ion-icon class="size-7 cursor-pointer shrink-0" name="refresh-circle" tooltip="Reset filters"></ion-icon>
            <div class="max-md:hidden">Reset Filters</div>
          </button>
        }
      </div>
      @if (isOpen) {
        <div class="border-t border-dotted border-blue-bright"></div>
      }
      <div
        id="filter-options"
        class="py-2 px-3 bg-white overflow-visible border-b shadow-xl border-x border-blue-bright rounded-b-2xl absolute w-[calc(100%-70px)] md:w-[calc(100%-71.5px)] ring-2 ring-blue-bright transition duration-100 origin-top"
        [ngClass]="{ 'opacity-0 scale-y-75 -z-50 transition-none': !isOpen, 'z-50': isOpen }"
      >
        <div class="absolute -top-1 w-full bg-white -ml-3 h-1 border-b border-grey-sky border-dashed"></div>
        @if (!inactiveSearchOptionGroups?.length) {
          <div class="flex flex-col text-center text-grey-mid items-center my-1 bg-grey-light-concrete p-2 rounded-lg">
            <h1 class="font-semibold">No Matching Filters Found</h1>
            <p class="font-normal pt-0.5">
              It seems there are no advanced search filters that match your typed input. You might want to refine your
              search criteria or try a different combination of characters.
            </p>
          </div>
        } @else {
          <h2 class="italic text-secondary pb-1">Filter by</h2>
        }
        <div class="flex items-start max-sm:flex-col">
          @for (optionGroup of inactiveSearchOptionGroups; track optionGroup.title; let i = $index) {
            <div class="mr-10">
              <small class="uppercase font-light">{{ optionGroup.title }}</small>
              <div>
                @for (option of optionGroup.searchOptions; track option.key) {
                  <button
                    class="btn-default px-2 py-0.5 ml-0 m-1.5 border-blue-bright text-blue-bright hover:text-white hover:bg-blue-bright"
                    [ngClass]="{
                      'bg-blue-bright text-white': searchValue?.length > 0 && focusedSearchOption?.key == option.key,
                      'bg-white': searchValue?.length == 0 || focusedSearchOption?.key != option.key,
                    }"
                    [id]="'search-option-' + option.key"
                    (click)="selectSearchOption(option)"
                  >
                    {{ option.title }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (noResultsFound) {
  <div class="empty-state shadow-none">
    <div class="rounded p-3 bg-grey-sky/20 text-grey-sky inline-flex mb-3">
      <ion-icon name="filter-outline" class="size-10"></ion-icon>
    </div>
    <h1>No results found</h1>
    <p class="text-sm font-normal">Try adjusting your search filter to find what you're looking for</p>
    <button class="btn-primary mt-10" (click)="removeAllSearchOptions()">Clear Filters</button>
  </div>
}
